<template>
  <div class="view match">
  <div class="prequiz">
    <div class="question-card">
      <div class="progress label">TicTacToe</div>
      <squizzy-squid mouth="inapp" eyes="eyes" />
      <p class="feedback-heading" > <p class="feedback-heading" style="font-size: 14px;">Take turns marking the board with X and win by placing 3 marks in a line. Start by tapping any box.</p>
      </p>
      <div v-if='started && game.text'>
        <button  class="btn-1 left" style="margin-right: 5px;">
           <span style="padding: 5px;float: left;">X</span>
           <span>{{playerx}}</span>
        </button>
        <button class="btn-1 right">
          <span style="padding: 5px;float: left;">O</span>
          <span>{{playero}}</span>
        </button>
        <!--<h1 v-if='!game.draw'><span>{{game.winner}}</span> wins!</h1>
        <h1 v-if='game.draw'><span>draw</span></h1>-->
      </div>
      <div  id='main' v-if='started'>
        <table class="grid" id='board'>
          <tr  v-for='row in board' v-bind:key="row[0].id">
            <td class="cell" v-for='box in row'
                v-bind:key="box.id"
                @click='router(box)'
                @mouseover='tick.play()'
                :class='{"bg active": box.bg}'>
              {{box.val}}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
    <div class="container" v-if="game.over">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>
  </div>

</template>
<script>
import SquizzySquid from "@/components/general/Gigly";
export default {
  components: {
    SquizzySquid
  },
  data() {
    return {
      feedbackTitle:'You deserve a break😃, Enjoy a game of tic tac toe',
      title:'Skip',
      started: false,
      mode: '',
      run: false,
      turn: 'X',
      playerx:'-',
      playero:'-',
      markers: {
        player: 'X',
        computer: 'O'
      },
      game: {
        text:false,
        over: false,
        winner: '',
        draw: false,
      },

      board: [
        [{id:'0',val: '', bg: ''}, {id:'1',val: '', bg: ''}, {id:'2',val: '', bg: ''}],
        [{id:'3',val: '', bg: ''}, {id:'4',val: '', bg: ''}, {id:'5',val: '', bg: ''}],
        [{id:'6',val: '', bg: ''}, {id:'7',val: '', bg: ''}, {id:'8',val: '', bg: ''}]
      ],

      windex: [
        [[0, 0], [0, 1], [0, 2]],
        [[1, 0], [1, 1], [1, 2]],
        [[2, 0], [2, 1], [2, 2]],
        [[0, 0], [1, 0], [2, 0]],
        [[0, 1], [1, 1], [2, 1]],
        [[0, 2], [1, 2], [2, 2]],
        [[0, 0], [1, 1], [2, 2]],
        [[0, 2], [1, 1], [2, 0]]
      ],

      tick: new Audio('https://dl.getdropbox.com/s/kgqqnei0yhv3r8n/219069__annabloom__click1.wav')
    }
  },//DATA
  mounted()
  {
    this.reset();
    this.game.text=true;
    this.mode = 'computer';
    this.turn = this.markers.player;
    this.start();
  },
  computed: {
    arr() {
      return this.board.map(x => x.map( y => y.val));
    },
    winArr() {
      return this.windex.map(x => x.map( y => this.board[y[0]][y[1]].val));
    },
    check(){
      const windex = this.winArr;
      const draw = this.arr.every(x => x.every(y => y !== ''));

      windex.forEach((x,ind) => {
        const vector = this.windex[ind];
        let over = false;

        if(x.every(y => y === 'X')){
          this.game.winner = 'X';
          this.playerx = '✔';
          over = true;
        }

        if(x.every(y => y === 'O')){
          this.game.winner = 'O';
          this.playero = '✔';
          over = true;
        }

        if(draw && this.game.winner == ''){
          this.game.draw = true;
          this.playero = 'X';
          this.playerx = 'X';
          over = true;
        }

        if(over){
          this.run = false;
          this.setWin(vector);
        }
      })
      return 0;
    },

    AIWinMove(){
      let move = '';
      const board = this.board;
      const combos = this.winArr;
      const AI = this.markers.computer;
      const AIStr = AI.repeat(3);
      combos.forEach((x,ind) => {
        if(x.join('') + AI === AIStr){
          let row = combos[ind];
          let col = row.indexOf('');
          let index = this.windex[ind][col];
          let box = board[index[0]][index[1]];
          move = box;
        }
      });
      return move;
    },

    AIBlockMove(){
      let move = '';
      const board = this.board;
      const combos = this.winArr;
      const player = this.markers.player;
      const playStr = player.repeat(3);
      combos.forEach((x,ind) => {
        if(x.join('') + player === playStr){
          let row = combos[ind];
          let col = row.indexOf('');
          let index = this.windex[ind][col];
          let box = board[index[0]][index[1]];
          move = box;
        }
      });
      return move;
    },

    randomMove(){
      const board = this.board;
      let counter = 0;
      const recurse = () => {
        if(counter == 8) return;
        counter++;
        let row = Math.floor(Math.random() * 2);
        let col = Math.floor(Math.random() * 2);
        if(board[row][col].val == ''){
          return board[row][col];
        } else
          return recurse();
      };
      return recurse();
    },

    AI(){
      const win = this.AIWinMove;
      const block = this.AIBlockMove;
      const random = this.randomMove;

      if(win != '')
        return win
      else if(win == '' && block != '')
        return block
      else
        return random
    }
  },//COMPUTED

  methods: {
    advance() {
      /*if (this.game.draw)
      {
        this.$store.commit('addScore',10);
      }
      if (this.game.winner ==='X')
      {
        this.$store.commit('addScore',30);
      }*/
      // Proceed if less than 10 rounds
      if (this.$store.state.round <= (this.$store.state.questions.length-2)) {
        this.$store.commit('pauseGame');
        //this.playerClickedCard = false;
        this.$store.commit('playerClickedCard',false);
        //this.resultsView = false;
        this.$store.commit('setResults',false);
        //this.timerCount = 30;
        setTimeout(() => {
          this.$store.commit('setIsOnBreak');
        }, 1500)
      }else
      {
        //this.$store.commit('isGameOver');
        setTimeout(() => {
          this.$store.commit('setIsOnBreak');
        }, 1500)

      }
    },
    init(mode){
      this.reset();
      this.mode = mode;

      if(mode === 'computer')
        this.turn = this.markers.player;

      this.start();
    },

    start(){
      this.run = true;
      this.started = true;
    },

    reset(){
      this.mode = '';
      this.run = false;
      this.game.over = false;
      this.game.winner = '';
      this.game.draw = false;

      this.board.forEach(x => {
        x.map(y => {y.val = ''; y.bg = ''})
      })
    },

    router(box){
      if(this.mode === 'player')
        this.mark(box);

      if(this.mode === 'computer' && box.val === ''){
        this.mark(box);
        setTimeout(() => {
          this.mark(this.AI);
        }, 300)
      }
    },

    mark(box){
      const run = this.run;

      if(box.val == '' && run){
        box.val = this.turn;
        this.turn = this.turn == 'X' ? 'O' : 'X';
        this.check;
      }
    },

    setWin(vector){
      if(!this.game.draw){
        vector.forEach( x => {
          this.board[x[0]][x[1]].bg = 'active'
        })
      }
      setTimeout(() => {
        //console.log('set win');
        this.game.over = true;
        if (this.game.over && (this.game.winner || this.game.draw))
        {
          this.advance();
        }
      }, 1500)
    }
  }//METHODS
};
</script>
<style>
  .bg{
    background-color: #00B16A!important;
  }
  .grid {
    background-color: #fff;
    color: #fff;
    width: 100%;
    border-collapse: collapse;
  }
  .cell {
    text-align: center;
    width: 33.333%;
    height: 90px;
    background-color: #34495e;
    /*border: 6px solid #2c3e50;*/
    font-size: 3.5em;
    font-family: 'Gochi Hand', sans-serif;
  }
  .cell:hover {
    background-color: #7f8c8d;
  }
  .cell::after {
    content: '';
    display: block;
  }
  .cell:first-of-type {
    border-left-color: transparent;
    border-top-color: transparent;
  }
  .cell:nth-of-type(2) {
    border-top-color: transparent;
  }
  .cell:nth-of-type(3) {
    border-right-color: transparent;
    border-top-color: transparent;
  }
  tr:nth-of-type(3) .cell {
    border-bottom-color: transparent;
  }
</style>
<style lang="sass" scoped>

@import url('https://fonts.googleapis.com/css?family=Asap:400,500,600&display=swap')

$main: 'Asap', sans-serif
$primary: #6C7A89
$secondary: #00B16A

*
  user-select: none
  box-sizing: border-box

.center
  top: 50%
  left: 50%

.column
  float: left
  padding: 10px

.farleft
  width: 25%

.right
  width: 25%

.farright
  width: 25%

.left
  width: 25%

.row:after
  content: ""
  display: table
  clear: both

span
  color: $secondary
.btn-1
  border-radius: 8px
  line-height: 16px
  text-transform: uppercase
  box-shadow: 0 4px 5px rgba(0,0,0,.16)
  border-bottom: 2px solid #14bdac
  color: rgba(0,0,0,.54)
  font-size: 24px
  margin: 0
  padding: 2px 4px 0
  text-align: right
  -webkit-transition: all 0.25s
  width: 45%

//<----Modal---->//
.modal-mask
  position: absolute
  z-index: 9998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background: rgba($primary, 0.5)
  transition: opacity .3s ease

.modal-container
  @extend .center

  width: 80%
  background: white
  border-radius: 10px
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33)
  transition: all .3s ease

.modal-body
  font-family: $main
  color: black
  font-size: 8vw
  margin: 0
  width: 100%
  text-align: center
  background: $primary
  color: white

.select_marker
  cursor: pointer

//<----/Modal---->//
#main
  display: grid
#welcome
  position: absolute
  top: 0
  right: 0
  bottom: 0
  left: 0
  background: $primary

.titleBlock
  @extend .center

  color: white
  font-family: $main
  text-align: center
  text-transform: uppercase
  letter-spacing: 4px

  h1
    font-size: 100px
    width: 100%

.mode
  font-size: 50px
  cursor: pointer

#board
  @extend .center
  /*margin-left: 6%
  /*margin-right: 6%
  border-collapse: separate
  border-spacing: 2px

td
  vertical-align: middle
/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px)
  .square
    display: grid
    width: 28vw
    height: 25vw
    background: $primary
    cursor: pointer
    font-family: $main
    font-size: 24vw
    line-height: 25vw
    text-align: center
    color: white

/* Smartphones (landscape) ----------- */
@media only screen and (min-width : 321px)
  .square
    display: grid
    width: 28vw
    height: 25vw
    background: $primary
    cursor: pointer
    font-family: $main
    font-size: 24vw
    line-height: 25vw
    text-align: center
    color: white

/* Smartphones (portrait) ----------- */
@media only screen and (max-width : 320px)
  .square
    display: grid
    width: 28vw
    height: 25vw
    background: $primary
    cursor: pointer
    font-family: $main
    font-size: 24vw
    line-height: 25vw
    text-align: center
    color: white

/* iPads (portrait and landscape) ----------- */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px)
 .square
  display: grid
  width: 8vw
  height: 8vw
  background: $primary
  cursor: pointer
  font-family: $main
  font-size: 8vw
  line-height: 8vw
  text-align: center
  color: white

/* iPads (portrait) ----------- */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait)
  .square
    display: grid
    width: 8vw
    height: 8vw
    background: $primary
    cursor: pointer
    font-family: $main
    font-size: 8vw
    line-height: 8vw
    text-align: center
    color: white

/**********iPad 3 **********/
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2)
 .square
  display: grid
  width: 8vw
  height: 8vw
  background: $primary
  cursor: pointer
  font-family: $main
  font-size: 8vw
  line-height: 8vw
  text-align: center
  color: white

.square
  display: grid
  width: 8vw
  height: 8vw
  background: $primary
  cursor: pointer
  font-family: $main
  font-size: 8vw
  line-height: 8vw
  text-align: center
  color: white

.square:hover
  opacity: .8
.square:active
  background: $secondary

#reset
  position: absolute
  top: 0
  right: 0
  bottom: 0
  left: 0
  background: $primary
.match
  display: grid
  grid-template-rows: auto
.question-card
  flex-grow: 1
  justify-content: center
  height: 100%
  display: grid
  grid-template-rows: min-content minmax(90px, 100px) min-content min-content
  height: 100%
  width: 100%
  overflow: hidden
  gap: 1rem
  @media screen and (max-height: 1024px)
    grid-template-rows: min-content minmax(90px, 100px) min-content min-content
  @media screen and (max-height: 737px)
    grid-template-rows: min-content minmax(90px, 100px) min-content min-content
  @media screen and (max-height: 569px)
    grid-template-rows: min-content minmax(90px, 100px) min-content min-content

.question
  display: grid
  grid-template-rows: min-content 1fr
  padding: 0 0.5rem

.title
  font-size: 2.5rem
  font-weight: bold
  text-align: center
  margin: auto
  padding-top: 1rem

.title-long
  font-size: $font-size-large

.title-with-image
  font-size: 1.5rem

.question-status
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center

.title
  font-size: $font-size-large
  margin: 0
  padding: 0

.confirmation-squizzy
  max-height: 150px
  margin-top: -0.5rem

#label
  display: grid
  justify-items: center
  width: 90%
  margin: 10px auto
  height: 22px

#progressBar
  width: 90%
  margin: 10px auto
  height: 22px
  background-color: $color-purple

#progressBar div
  height: 100%
  text-align: right
  padding: 0 10px
  line-height: 22px /* same as #progressBar height if we want text middle aligned */
  width: 0
  background-color: $color-red
  box-sizing: border-box

.counter
  /*position: absolute*/
  color: white
  font-weight: 400
  font-size: 1em

.label
  display: flex
  align-items: center
  justify-content: center

// Colors variables
$primary: #4285F4

// blue
$success: #34A853

// green
$danger: #EA4335

// red
$warning: #FBBC05

// yellow

// Container and shapes dimentions
$containerDimentions: 30px
$shapeDimentions: 10px

//shape translate amount
$amount: 20px

html, body
  margin: 0
  width: 100%
  height: 100%
  background-color: #03002E

body
  display: flex
  justify-content: center
  align-items: center

*
  box-sizing: border-box

//colors

.container
  position: absolute
  top: 50%
  left: 50%
  z-index: 999
  width: $containerDimentions
  height: $containerDimentions
  border-radius: $containerDimentions / 2
  animation: rotation 1s infinite

  .shape
    position: absolute
    width: $shapeDimentions
    height: $shapeDimentions
    border-radius: $shapeDimentions / 2

    &.shape-1
      left: 0
      background-color: $primary

    &.shape-2
      right: 0
      background-color: $success

    &.shape-3
      bottom: 0
      background-color: $warning

    &.shape-4
      bottom: 0
      right: 0
      background-color: $danger

  @for $i from 1 through 4
    .shape-#{$i}
      animation: shape#{$i} 0.5s infinite alternate

@keyframes rotation
  from
    transform: rotate(0deg)

  to
    transform: rotate(360deg)

=shapeTranslate($index, $tx, $ty)
  @keyframes shape#{$index}
    from
      transform: translate(0, 0)

    to
      transform: translate($tx, $ty)

+shapeTranslate(1, $amount, $amount)
+shapeTranslate(2, -$amount, $amount)
+shapeTranslate(3, $amount, -$amount)
+shapeTranslate(4, -$amount, -$amount)
</style>
